import React, { useState, useEffect } from 'react';

const navItems = [
  { id: 'home', label: 'HOME' },
  { id: 'about', label: 'ABOUT' },
  { id: 'projects', label: 'PROJECTS' },
  { id: 'contact', label: 'CONTACT' }
];

function Navigation({ scrollToSection }) {
  const [highlighted, setHighlighted] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleClick = (id) => {
    scrollToSection(id);
    setHighlighted(id);
    setTimeout(() => setHighlighted(null), 250);
  };
  return (
    <header 
      className="fixed w-full z-40 transition-all duration-500 top-0"
    >
        <nav 
          className="backdrop-blur-lg transition-all duration-300"
          style={{
            backgroundColor: 'transparent',
            backdropFilter: 'blur(16px)',
            WebkitBackdropFilter: 'blur(16px)'
          }}
        >
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div />
            {/* Desktop Navigation */}
            <div className="hidden md:flex space-x-4">
              {navItems.map(({ id, label }) => (
                <button
                  key={id}
                  onClick={() => handleClick(id)}
            className={`px-4 py-2 rounded-md text-sm font-medium text-white transition-all duration-300 ${
                  highlighted === id
                    ? 'bg-blue-400 text-black'
                    : 'bg-transparent hover:bg-gray-800 hover:text-gray-200'
                }`}
                >
                  {label}
                </button>
              ))}
            </div>
            {/* Mobile Navigation */}
            <div className="flex md:hidden space-x-2">
              {navItems.map(({ id, label }) => (
                <button
                  key={id}
                  onClick={() => handleClick(id)}
            className={`px-2 py-1 rounded-md text-xs font-medium text-white transition-all duration-300 ${
                  highlighted === id
                    ? 'bg-blue-400 text-black'
                    : 'bg-transparent hover:bg-gray-800 hover:text-gray-200'
                }`}
                >
                  {label}
                </button>
              ))}
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Navigation;
